import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-647244f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"height":"100%","width":"100%","background-color":"rgba(223, 223, 223, 0.09)","position":"fixed"}
}
const _hoisted_2 = {
  class: "text-gray-700",
  style: {"font-weight":"400","font-size":"1.2rem"}
}

import { ref, onMounted } from "vue"
import { AtomButton } from "@/components/atoms"


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeLGPD',
  setup(__props) {


const allowedCookies = ref(true);

function setCookies(save = false) {
  if (save) document.cookie = "allow_cookies=true"
  allowedCookies.value = true;
}

onMounted(() => {
  setTimeout(() => {
    const cookies = document.cookie.split(";");
    const index = cookies.findIndex(e => e.includes("allow_cookies"))

    if (index !== -1) {
      setCookies(cookies[index].split("=")[1] !== "true" ?? false);
      return;
    }

    allowedCookies.value = false;
  }, 1000)
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (!allowedCookies.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!allowedCookies.value)
              ? (_openBlock(), _createBlock(_component_v_container, {
                  key: 0,
                  fluid: "",
                  class: "p-0",
                  style: {"position":"fixed","height":"10%","bottom":"0px","background-color":"rgba(223, 223, 223, 0.248)"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      "no-gutters": "",
                      align: "center",
                      class: "h-100",
                      style: {"flex-wrap":"nowrap"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "8" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('message.login.cookies')) + ".", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, { cols: "1" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(AtomButton), {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (setCookies(true))),
                              class: "cursor-pointer"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.login.agree')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})